// extracted by mini-css-extract-plugin
module.exports = {"preloader":"Preloader_preloader__b8K5E","isFullScreenPreloader":"Preloader_isFullScreenPreloader__aetnt","image":"Preloader_image__Fs-5O","text":"Preloader_text__1nR0g"};